import Glide from '@glidejs/glide';

export const modalSetting = () => {
  // Check if modal component exist - safety check
  if (document.querySelector('.modal-open') || document.querySelector('.modal-close')) {
    linkTableModal('link-table');
    virtualTourModal('virtual-tour');
    imageGridModal('grid-item');
  }
  blogSummaryModal('blog-summary');
}

const virtualTourModal = (modalName) => {
  if (document.querySelector('.modal-open.' + modalName)) {
    // Modal Popup
    document.querySelector('.modal-open.' + modalName).addEventListener('click', toggleModal);
    document.querySelector('.modal-open.' + modalName).modalName = modalName;
  
    document.querySelector('.modal-close.' + modalName).addEventListener('click', (e) => {pauseVideo(); toggleModal(e);});
    document.querySelector('.modal-close.' + modalName).modalName = modalName;
  
    // Glider
    let glide = new Glide('.virtual-tour-glide',  { 
      type: 'carousel',
      startAt: 0,
      perView: 1,
      slideWidth: 700,
      gap: 0,
      autoplay: false
    });
  
    glide.on(['mount.after', 'run'], () => {
      const currentSlide = glide.index + 1;
  
      // Update Current Slide No.
      document.querySelector('.virtual-tour-image-index').innerHTML = currentSlide < 10 ? `${currentSlide}` : `${currentSlide}`;
      
      // Update Individual Image Caption
      const captionElement = document.querySelector(`div[data-glide-virtual-tour-index="` + (currentSlide) + '"');
      if (document.querySelector("#virtual_tour_caption") && captionElement) {
        document.querySelector("#virtual_tour_caption").innerHTML = captionElement.innerHTML;
      }
    });
  
    glide.mount();
  }
  
}

const imageGridModal = (modalName) => {
  if (document.querySelector('.modal-open.' + modalName)) {
    document.querySelectorAll('.modal-open.' + modalName).forEach(function(item, key){
      item.addEventListener('click', function(e){
        document.addEventListener('keyup', closeModal, {once: true});
        glide.update({ startAt: key })
        toggleModal(e);
      });
      item.modalName = "virtual-tour";
    });

    // Glider
    let glide = new Glide('.image-grid-glide',  { 
      type: 'carousel',
      startAt: 0,
      perView: 1,
      slideWidth: 700,
      gap: 0,
      autoplay: false
    });
  
    glide.on(['mount.after', 'run', 'update'], () => {
      const currentSlide = glide.index + 1;
  
      // Update Current Slide No.
      document.querySelector('.virtual-tour-image-index').innerHTML = currentSlide < 10 ? `${currentSlide}` : `${currentSlide}`;
      
      // Update Individual Image Caption
      const captionElement = document.querySelector(`div[data-glide-virtual-tour-index="` + (currentSlide) + '"');
      if (document.querySelector("#virtual_tour_caption") && captionElement) {
        document.querySelector("#virtual_tour_caption").innerHTML = captionElement.innerHTML;
      }
    });
  
    glide.mount(); 

    document.querySelector('.modal-close.virtual-tour').addEventListener('click', (e) => {pauseVideo(); toggleModal(e);});
    document.querySelector('.modal-close.virtual-tour').modalName = "virtual-tour";

  }
}

function closeModal(e){
  // console.log('closemodal');
  pauseVideo(); 
  e.currentTarget.modalName = "virtual-tour";
  toggleModal(e);
}

const linkTableModal = (modalName) => {
  document.querySelectorAll('.modal-open.' + modalName).forEach((element) => {
    element.addEventListener('click', toggleModal);
    element.modalName = modalName;
    element.modalId = element.getAttribute('modal-id');
  });
  document.querySelectorAll('.modal-close.' + modalName).forEach((element) => {
    element.addEventListener('click', toggleModal);
    element.modalName = modalName;
    element.modalId = element.getAttribute('modal-id');
  });
  
}

const blogSummaryModal = (summaryClass) => {
  const summaries = document.querySelectorAll(`.${summaryClass}`);
  summaries.forEach(summary => {
    summary.addEventListener("click", (e) => {
      const modalId = summary.dataset.modal;
      const modal = document.querySelector(`#${modalId}`);
      modal.showModal();
      modal.querySelectorAll('.close-button').forEach( button => {
        button.addEventListener("click", e => {
          modal.close();
        });
      });
      modal.addEventListener('click', (e) => {
        if (e.target == modal) {
          modal.close();
        }
      })
    });
  });
}

const toggleModal = (e) => {
  let modalId = ''
  if (e.currentTarget.modalId) {
    modalId = '#' + e.currentTarget.modalId;
    console.log({modalId});
  }

  if (document.querySelector('.modal-' + e.currentTarget.modalName + modalId)) {
    document.querySelector('.modal-' + e.currentTarget.modalName + modalId).classList.toggle('modal-toggle');

  }
  if (document.querySelector('#nav-toggle-backdrop')) {
    document.querySelector('#nav-toggle-backdrop').classList.toggle('nav-toggle');
  }
}

const pauseVideo = () => {
  document.querySelector('.modal-virtual-tour').querySelectorAll('iframe').forEach((element) => {
    let iframeSrc = element.src;
    element.src = iframeSrc;
  });
}
